import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { addToChainAfter, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import {
    chain,
    WaitForPricingAndInventory,
} from "@insite/client-framework/Store/Pages/StaticList/Handlers/LoadWishListIfNeeded";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { MGBW_IS_CONFIGURABLE } from "@tSurya/Common/MgbwPropertyKeys";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        wishListId: string;
    },
    GetWishListsApiParameter,
    WishListModel,
    {
        wishList: WishListModel;
        pricingLoaded?: true;
        inventoryLoaded?: true;
        productInfosByWishListLineId: SafeDictionary<ProductInfo>;
    }
>;

/**
 * Real-time pricing does not apply for MGBW configurator products. The backend persists the
 * configurator price on the wish list line itself, so we restore that price after RT pricing.
 */
export const OverrideConfiguratorPrices: HandlerType = props => {
    const { wishList, productInfosByWishListLineId } = props;
    if (!wishList.wishListLineCollection?.length) {
        return;
    }

    wishList.wishListLineCollection.forEach(wishListLine => {
        const isConfiguratorProduct = wishListLine.properties?.[MGBW_IS_CONFIGURABLE] === "true";
        if (!isConfiguratorProduct || !wishListLine.pricing) {
            return;
        }

        const productInfo = productInfosByWishListLineId[wishListLine.id];
        if (productInfo) {
            productInfo.pricing = wishListLine.pricing;
            productInfo.failedToLoadPricing = undefined;
        }
    });
};

addToChainAfter(chain, WaitForPricingAndInventory, OverrideConfiguratorPrices);
